var map = {
	"./hand-0.png": 258,
	"./hand-1.png": 363,
	"./hand-2.png": 504,
	"./hand-3.png": 369,
	"./hand-4.png": 278,
	"./hand-5.png": 119,
	"./hand-6.png": 116,
	"./hand-7.png": 381,
	"./hand-8.png": 178,
	"./hand-9.png": 3
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 267;